import React, { useCallback } from 'react'
import cx from 'classnames'
import { BtnV2, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { billing, UpgradeSource } from 'common/billing'
import { PRICING_LINK, TRIAL_PERIOD_IN_DAYS } from 'common/billing/constants'
import { getIsEnableNewCtaOnBar } from 'common/billing/entities/upgradeRequest/selectors'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const ActivateProTrialNotification = () => {
  useDidMountEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.PRO_TRIAL_EXPERIMENT.SHOWN')
  })

  const isEnableNewCtaOnBar = useAppSelector(getIsEnableNewCtaOnBar)

  const handleRequestUpgradeClick = useCallback(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.PRO_TRIAL_EXPERIMENT.ACTIVATE_PRO_TRIAL.CLICKED')
    billing.requestUpgrade({
      source: UpgradeSource.NOTIFICATION_BAR_PRO_TRIAL_EXPERIMENT,
    })
  }, [])

  const handleOpenPricingClick = () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.PRO_TRIAL_EXPERIMENT.PRICING.CLICKED')
    window.open(PRICING_LINK, '_blank')
  }

  return (
    <>
      <span>{l.translate('Upgrade to get more Active Contacts and boost engagement')}</span>
      <BtnV2
        variant="success"
        onClick={handleRequestUpgradeClick}
        className="m-l-sm"
        leftIcon={isEnableNewCtaOnBar ? 'MagicWand' : null}
      >
        {l.translate('Try {daysCount} days for free', {
          daysCount: TRIAL_PERIOD_IN_DAYS,
        })}
      </BtnV2>
      <a onClick={handleOpenPricingClick} className={cx(cm.viewPricing, 'm-l-sm')}>
        {l.translate('View pricing')}
      </a>
    </>
  )
}
